import 'url-polyfill';
import 'object-assign';
import './utils/polyfills';
import WPSLog from './utils/console';

let isES6Supported = (function() {
  let detection = 'class ಠ_ಠ extends Array{constructor(j=`a`,...c){const q=(({u: e})=>{return {[`${c}`]:Symbol(j)};})({});super(j,q,...c)}}new Promise(f=>{const a=function*(){return "\\u{20BB7}".match(/./u)[0].length===2||!0};for (let z of a()){const [x,y,w,k]=[new Set(),new WeakSet(),new Map(), new WeakMap()];break}f(new Proxy({},{get:(h,i) =>i in h ?h[i]:"j".repeat(0o2)}))}).then(t => new ಠ_ಠ(t.d))';
  let result = true;
  try {
    eval(detection);
  } catch (e) {
    result = false;
  }
  return result;
})();

let moduleName = 'emarsys_webpersonalization';
let submodule = 'es5';
const SOURCE = {
  PARENT: 'parent',
  TIMEOUT: 'timeout'
};

if (isES6Supported) {
  submodule = 'es6';
}

if (!ScarabUtil.emarsysModules[moduleName].selector) {
  ScarabUtil.emarsysModules[moduleName].selector = {
    path: '//static.scarabresearch.com/wpjs/selector.js',
    devPath: 'http://local.scarabresearch.com:3000/dist/selector.js'
  };
}

function hashObjectHas(hashObject, prop) {
  return hashObject && (hashObject[prop] === 'true' || hashObject[prop] === true);
}

function hasWindowConfigInName() {
  return window.name.indexOf('wps-window') === 0;
}

function getWindowConfigFromName() {
  return JSON.parse(window.name.split('=')[1]);
}

const windowConfigPromise = new Promise(resolve => {
  const hasOpener = window.opener !== null;
  const hasParent = window.parent !== window;

  if (!hasOpener && !hasParent) {
    resolve({
      mode: 'wps'
    });
  } else if (hasWindowConfigInName()) {
    let config = getWindowConfigFromName();
    config.source = 'parent';

    resolve(config);
  } else {
    const listener = event => {
      try {
        const message = JSON.parse(event.data);
        if (message.command && message.command === 'wp.setWindowConfig') {
          const windowConfig = JSON.parse(message.config.split('=')[1]);
          windowConfig.source = SOURCE.PARENT;
          windowConfig.channelScope = message.channelScope;
          WPSLog.info('windowConfig:', windowConfig);
          resolve(windowConfig);
        }
      } catch (error) {}
    };

    if (window.addEventListener) {
      window.addEventListener('message', listener, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', listener);
    }

    const parentWindow = window.opener || window.parent;
    if (parentWindow) {
      parentWindow.postMessage(JSON.stringify({ command: 'wp.getWindowConfig' }), '*');
    }
  }
});

const windowConfigTimeout = new Promise(resolve => {
  window.setTimeout(() => {
    WPSLog.info('handshake timeout');
    resolve({
      source: SOURCE.TIMEOUT
    });
  }, 300, {});
});

WPSLog.info('buildenv', process.env.NODE_ENV);

Promise.race([windowConfigPromise, windowConfigTimeout]).then(windowConfig => {
  let selector = false;
  if (ScarabUtil) {
    let hashObject = ScarabUtil.parseHashString();
    selector = hashObjectHas(hashObject, 'selector') || windowConfig.mode === 'selector';
  }

  if (selector) {
    submodule = 'selector';
  }

  let config = {};
  if (ScarabUtil && ScarabUtil.loadedModules && ScarabUtil.loadedModules[moduleName]) {
    config = ScarabUtil.loadedModules[moduleName].config;
    delete ScarabUtil.emarsysModules[moduleName].status;
  }

  config.windowConfig = windowConfig;
  WPSLog.info('mode:', windowConfig.mode);

  ScarabUtil.loadModule(window, moduleName, config, submodule, config.cb);
});
